const VIDEO_SELECTOR = '.product-media deferred-media video';

function play(video) {
  video.muted = true;
  video.play().catch(() => {});
}

function pause(video) {
  video.pause();
}

function isSlideActive(video) {
  const slide = video.closest('slideshow-slide');
  if (!slide) return true;
  return slide.getAttribute('aria-hidden') !== 'true';
}

function isInViewport(video) {
  const rect = video.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0 && rect.width > 0;
}

function update(video) {
  if (isSlideActive(video) && isInViewport(video)) {
    play(video);
  } else {
    pause(video);
  }
}

function init() {
  const videos = document.querySelectorAll(VIDEO_SELECTOR);
  if (!videos.length) return;

  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        update(entry.target);
      }
    },
    { threshold: 0.3 }
  );

  for (const video of videos) {
    visibilityObserver.observe(video);

    const slide = video.closest('slideshow-slide');
    if (slide) {
      const slideObserver = new MutationObserver(() => update(video));
      slideObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
